// WidgetModal.js
import React from 'react';
import { Modal, Button} from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css';
import '../css/widget/widget.modal.css'

class WidgetModal extends React.Component
{ 
    constructor(props)
    {
        super( props );

        this.state = {
            show: false,
            options : props.options
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.confirm = this.confirm.bind(this);
        
        if( this.props.onRef!==undefined )
        {
            this.props.onRef(this)
        }
    }

    confirm()
    {
        const { options } = this.props;

        if( options.confirmFunction!==undefined )
        {
            options.confirmFunction();
        }

        this.setState({ show: false });
    }

    close()
    {
        const { options } = this.props;

        if( options.cancelFunction!==undefined )
        {
            options.cancelFunction();
        }

        this.setState({ show: false });
    }

    open()
    {
        this.setState({ show: true });
    }

    render()
    {
        const { options } = this.state;

        let backdrop = 'static';

        if( options.backdrop!==undefined && options.backdrop!==null )
        {
            backdrop = options.backdrop;
        }

        if( options.button!==undefined &&  options.button===false )
        {
            return (
                <div className="widget-model">
                    <Modal backdrop={backdrop} show={this.state.show} onHide={this.close} size={options.size}>
                        <Modal.Header>
                            <Modal.Title>{options.title}</Modal.Title>
                        </Modal.Header>
    
                        <Modal.Body>
                            {this.props.children}
                        </Modal.Body> 
                    </Modal>
                </div>
            )
        }
        else
        {
            if( options.confirmFunction!==undefined )
            {
                return (
                    <div className="widget-model">
                        <Modal backdrop={backdrop} show={this.state.show} onHide={this.close} size={options.size}>
                            <Modal.Header>
                                <Modal.Title>{options.title}</Modal.Title>
                            </Modal.Header>
        
                            <Modal.Body>
                                {this.props.children} 
                            </Modal.Body>
        
                            <Modal.Footer>
                                <Button onClick={this.confirm} appearance="primary" style={{background:"#2C70F6"}}>
                                {
                                    options.confirm!==undefined ?  options.confirm : "确定"
                                }
                                </Button>
        
                                <Button onClick={this.close} appearance="default">
                                {
                                    options.cancel!==undefined ?  options.cancel : "取消"
                                }
                                </Button>                 
                            </Modal.Footer>   
                        </Modal>
                    </div>
                )
            }
            else 
            {
                return (
                    <div className="widget-model">
                        <Modal backdrop={backdrop} show={this.state.show} onHide={this.close} size={options.size}>
                            <Modal.Header>
                                <Modal.Title>{options.title}</Modal.Title>
                            </Modal.Header>
        
                            <Modal.Body>
                                {this.props.children}
                            </Modal.Body>
        
                            <Modal.Footer>
                                <Button onClick={this.close} appearance="default">
                                {
                                    options.cancel!==undefined ?  options.cancel : "取消"
                                }
                                </Button>                 
                            </Modal.Footer>   
                        </Modal>
                    </div>
                )
            }
        }
    }
}

export default WidgetModal